/*
 *
 *  * Copyright(c) 2022 General Electric Company. All rights reserved.
 *  *
 *  * The copyright to the computer software herein is the property of
 *  * General Electric Company. The software may be used and/or copied only
 *  * with the written permission of General Electric Company or in accordance
 *  * with the terms and conditions stipulated in the agreement/contract
 *  * under which the software has been supplied.
 *
 */

import { ChangeDetectorRef, Component } from '@angular/core';
import { AdvanceSearchService } from '@app/common/services/advance-search/advance-search.service';
import { ModalConfig, ModalRef } from '@wfm/core';
import { Logger } from '@core/lib/services';
import { TextValidatorService } from '@app/common/services/validators/text-validator.service';

const log = new Logger('SaveWorkListComponent');

@Component({
  selector: 'app-save-work-list',
  templateUrl: './save-work-list.component.html',
  styleUrls: ['./save-work-list.component.scss']
})
export class SaveWorkListComponent {
  isLoading = false;

  constructor(
    public config: ModalConfig,
    public modalRef: ModalRef,
    private advanceSearchService: AdvanceSearchService,
    private textValidatorService: TextValidatorService,
    private cd: ChangeDetectorRef
  ) {}

  clearInputField(key: string) {
    this.config.data.searchParams[key] = undefined;
    this.config.data.searchParamsError[key] = undefined;
  }

  inputValueChange(key: string) {
    this.config.data.searchParamsError[key] = undefined;
    this.textValidatorService.isValidInput(
      key,
      this.config.data.searchParams.worklistName,
      this.config.data.searchParamsError
    );
  }

  save() {
    this.isLoading = true;
    this.advanceSearchService
      .saveCustomWorklist(this.config.data.searchParams)
      .then(() => {
        this.config.data.searchParamsError['worklistName'] = undefined;
        this.modalRef.close('YES');
        this.isLoading = false;
      })
      .catch((msg: string) => {
        log.error(`save() - '${this.config.data.searchParams['worklistName']}' ${msg}`);
        this.config.data.searchParamsError.worklistName = msg;
        this.cd.detectChanges();
      })
      .finally(() => {
        this.isLoading = false;
        this.cd.detectChanges();
      });
  }

  cancel() {
    this.clearInputField('worklistName');
    this.modalRef.close('NO');
  }
}
